import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=1a75f36a&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=1a75f36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a75f36a",
  null
  
)

export default component.exports